<template>
    <b-container>
        <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">Water Data</div>
      <b-button size="sm" @click="requestDownload()" v-if="admin">
        Export Water Data
      </b-button>
        <ag-grid-vue style="width: 100%; height: 500px;"
                     class="ag-theme-balham"
                     :columnDefs="this.waterColumnDefs"
                     :rowData="this.waterRowData">
        </ag-grid-vue>
    </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import {FileUtils} from "@/lib/FileUtils";
import {
  isAdmin,
  isAdminClass,
  isAdminOrCertifier,
  isAdminVineyardAdminOrCertifier,
  isCertifier,
  isNonCertifierAdmin,
  isPureAdmin,
  isVineyardAdmin,
  isVineyardAdminMeth
} from "@/lib/UserUtils";

export default {
  name: "WaterMetricTable",
  props: {groupId: String},
  components: {
    AgGridVue
  },

  data() {
    return {
      waterColumnDefs: null,
      waterRowData: [],
                bottomData1: [],
                rowStyle1: {fontWeight: 'bold'},
                theGroupId: this.groupId,
                admin: isAdmin()
            }
        },
        mounted() {
            /*            this.gridApi1 = this.topGridOptions1.api;
                        this.gridColumnApi1 = this.topGridOptions1.columnApi;*/
        },
        beforeMount() {

            this.waterColumnDefs = [
                {
                    headerName: 'Month', field: 'meterUsage'
                },
                {headerName: 'Gallons Winery Process, Tasting/Offices', field: 'wineryProcess'},
                {headerName: 'Gallons Landscaping', field: 'landscaping'},
                {headerName: 'Gallons Other', field: 'tastingOffices'},
                {headerName: 'Wastewater', field: 'wastewater'}

            ];

            let theGroup = this.theGroupId;
            this.$http.get("metrics/water/graph/full/" + theGroup)
                .then(resultWater => {
                    let self = this;
                    self.waterRowData = resultWater.data;
                    self.waterRowData.wastewater = self.waterRowData.tastingOffices;
                    console.log(self.waterRowData.wastewater);
                }).catch(
                error => {
                    console.log(error)
                });
            console.log("Water Row Data in WaterMetricTable is above.")

        },
        methods: {
          requestDownload() {
            let self = this;
            this.$http.get(`metrics/download/${self.theGroupId}/water/wine`, {responseType: "blob"})
                .then(async response => {
                  FileUtils.saveExcelToDisk(response);
                });
          },
        }
    }

    function getCharCodeFromEvent(event) {
        event = event || window.event;
        return typeof event.which === "undefined" ? event.keyCode : event.which;
    }

    function isCharNumeric(charStr) {
        return !!/\d/.test(charStr);
    }

    function isKeyPressedNumeric(event) {
        var charCode = getCharCodeFromEvent(event);
        var charStr = String.fromCharCode(charCode);
        return isCharNumeric(charStr);
    }
</script>

<style scoped>

</style>
